import React, { useState, useEffect, useRef } from "react";
import Loader from "../loader/loader";
import ManageCallStatus from "./ManageCallStatus";
import { useGetAllCallStatusMutation, useGetCallStatusMutation } from "./Api";
import Pagination from "../Pagination/Pagination";
import { Logout, shouldLogout } from '../Common/Common'
import { useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";

const CallStatus = () => {

    const [getAllCallStatusApi, { isLoading }] = useGetAllCallStatusMutation()
    const [getCallStatusApi, { isLoading: getCallStatusLoading }] = useGetCallStatusMutation()

    const [CallStatus, setCallStatus] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [status, setStatus] = useState(false)
    const [search, setSearch] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState(search);
    const requestIdRef = useRef(0);
    const navigate = useNavigate()

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearch(search);
        }, 1000); // 1000ms delay

        return () => clearTimeout(handler); // cleanup on next effect
    }, [search]);

    useEffect(() => {
        getAllCallStatus()
    }, [rowsPerPage, currentPage, status, debouncedSearch]);

    useEffect(() => {
        setCurrentPage(1);
    }, [debouncedSearch]);

    const getAllCallStatus = async () => {
        try {
            const requestId = ++requestIdRef.current;

            const response = await getAllCallStatusApi({
                page: currentPage,
                limit: rowsPerPage,
                search: debouncedSearch.trim()
            })

            if (requestId !== requestIdRef.current) return;

            if (response?.data?.success) {
                setCallStatus(response?.data?.data?.callStatus)
                setTotalRecords(response?.data?.data?.pagination?.total || 0);
                setTotalPages(response?.data?.data?.pagination?.totalPages || 1);
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }


    const startEntry = totalRecords === 0
        ? 0
        : (currentPage - 1) * rowsPerPage + 1;

    const endEntry = Math.min(currentPage * rowsPerPage, totalRecords);


    // Drawer open close
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);


    // Open drawer for creating new category
    const handleCreateCategory = () => {
        setIsDrawerOpen(true);
    };

    const handleCloseDrawer = () => {
        setIsDrawerOpen(false);
    };

    const handleSave = () => {
        handleCloseDrawer(); // Close 
        setStatus(!status)  // for get new data after new role upload
    };


    // Update Drawer

    const [isUpdateDrawerOpen, setIsUpdateDrawerOpen] = useState(false);
    const [callStatusData, setCallStatusData] = useState()

    const handleUpdateCloseDrawer = () => {
        setIsUpdateDrawerOpen(false);
    };

    const handleUpdateSave = () => {
        handleUpdateCloseDrawer(); // close toggle
        setStatus(!status)  // for get new data after new role upload
    };


    const getCallStatus = async (id) => {
        try {
            const response = await getCallStatusApi({ id: id })

            if (response?.data?.success) {
                setIsUpdateDrawerOpen(true)
                setCallStatusData(response?.data?.data)
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    return (
        <div>
            {isLoading || getCallStatusLoading ? <Loader /> :
                <div>
                    {/* Header */}
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <ul className="breadcrumb mb-0">
                                <li className="breadcrumb-item">System Setting</li>
                                <li className="breadcrumb-item active">Status Management</li>
                            </ul>
                        </div>
                    </div>

                    <div className="main-content">
                        <div className="row">
                            <div className="p-6">
                                {/* Title */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                        <h3 className="h4 mb-1 drawer-header">
                                            Status Management
                                        </h3>
                                        <p className="mb-0 text-muted">
                                            Manage agent availability statuses
                                        </p>
                                    </div>
                                    <button className="btn btn-primary" onClick={handleCreateCategory}>
                                        Add Status
                                    </button>
                                </div>


                                <div className="card p-3 mb-4">

                                    <div className="card shadow-sm border-0 p-3 mb-4">
                                        <div className="row justify-content-end g-3">

                                            {/* Search */}
                                            <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                                                {/* <label className="form-label small text-muted mb-1">Search</label> */}
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    placeholder="Search call status by name..."
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                />
                                            </div>

                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-hover mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Status Name</th>
                                                    <th>Description</th>
                                                    <th>Colour</th>
                                                    <th>Alert Message</th>
                                                    <th>Status</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!isLoading && CallStatus?.length > 0 ? CallStatus?.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            {item.statusName}
                                                        </td>
                                                        <td style={{
                                                            whiteSpace: "normal",
                                                            wordBreak: "break-word",
                                                            maxWidth: "250px"
                                                        }}>
                                                            {item.description ? item.description : "-"}
                                                        </td>
                                                        <td>
                                                            <span
                                                                className="color-dot"
                                                                style={{ backgroundColor: item.colour }}
                                                            ></span>  {item.colour.charAt(0).toUpperCase() + item.colour.slice(1)}
                                                        </td>
                                                        <td style={{
                                                            whiteSpace: "normal",
                                                            wordBreak: "break-word",
                                                            maxWidth: "250px"
                                                        }}>
                                                            {item.alert_message ? item.alert_message : "-"}
                                                        </td>
                                                        <td>
                                                            <span className={`badge ${item.status === "Active" ? "bg-success" : "bg-danger"}`}>
                                                                {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                                                            </span>
                                                        </td>
                                                        <td style={{ cursor: "pointer" }}
                                                            onClick={() => getCallStatus(item.id)}>
                                                            <FaEdit size={18} />
                                                        </td>

                                                    </tr>
                                                )) : (
                                                    <tr>
                                                        <td colSpan="6" className="text-center text-muted py-4" style={{ fontStyle: "italic", backgroundColor: "#f9f9f9" }}>
                                                            No data found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                        {/* Pagination */}

                                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 gap-2">

                                            <div className="d-flex align-items-center gap-1 small">

                                                <span>Show</span>

                                                <select
                                                    className="form-select form-select-sm page-size-select"
                                                    value={rowsPerPage}
                                                    onChange={(e) => {
                                                        setRowsPerPage(Number(e.target.value));
                                                        setCurrentPage(1);
                                                    }}
                                                >
                                                    <option value={5}>5</option>
                                                    <option value={10}>10</option>
                                                    <option value={15}>15</option>
                                                </select>

                                                <span>entries</span>

                                            </div>

                                            <div className="small text-muted">
                                                Showing {startEntry} to {endEntry} of {totalRecords} entries
                                            </div>

                                            <Pagination
                                                currentPage={currentPage}
                                                totalPages={totalPages}
                                                maxPagesToShow={rowsPerPage}
                                                onPageChange={(page) => setCurrentPage(page)}
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {isDrawerOpen && (
                        <ManageCallStatus
                            mode="add"
                            onClose={handleCloseDrawer}
                            onSave={handleSave}
                        />

                    )}

                    {isUpdateDrawerOpen && (
                        <ManageCallStatus
                            mode="update"
                            onClose={handleUpdateCloseDrawer}
                            onSave={handleUpdateSave}
                            data={callStatusData}
                        />
                    )}
                </div>

            }
        </div>

    );
};

export default CallStatus;  
